import "./AboutUs.module.css";
import Navigering from "@/reusable_sections/Header";
import LocalPartnerForFreshAir from "./sections/LocalPartnerForFreshAir";
import MeetTheTeam from "./sections/MeetTheTeam";
import SidfotInfo from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Navigering />
      <LocalPartnerForFreshAir />
      <MeetTheTeam />
      <SidfotInfo />
    </div>;
}